import { BaseNomenclature } from "./baseNomenclature.model";

export class CommentField extends BaseNomenclature {
    constructor() {
    super()
    this.collection_name="comment_field";  
    }
}